<template>
    <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M7 12a1 1 0 1 1 0 2H2a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v2.402C4.705 8.33 7.337 7 10.291 7c3.91 0 7.254 2.328 8.634 5.625a.989.989 0 0 1-.57 1.302c-.53.207-1.133-.04-1.348-.552C15.932 10.808 13.33 9 10.291 9c-2.46 0-4.635 1.185-5.944 3H7Z" />
    </svg>
</template>
